import ApiClient from './ApiClient'
import Api from './Api'
import { functions } from '../../firebase'
import { createFormData } from './formData'

const baseUrl = () => {
  if (process && process.env && process.env.NODE_ENV === 'development') {
    return (
      process.env.VUE_APP_AUTHENTIGATE_API_URL ||
      'http://localhost:5002/openlaw-dev/us-central1/app/'
    )
  }
  return '/'
}

export default {
  install(Vue, _options) {
    Vue.prototype.$api = new Api(
      new ApiClient(baseUrl()),
      functions,
      createFormData
    )
  }
}
